import React, { useState } from 'react'
import ConfirmationModal from "../../../components/global/modal/ConfirmationModal.jsx";
import toast from "react-hot-toast";
import { SendUserCredentialsApi } from "../../../api/request/client.js";

function SendCredentials({ isOpenModal, setIsOpenModal, id }) {
  const [isReqLoading, setIsReqLoading] = useState(false);

  const SendCredentials = async () => {
    try {
      setIsReqLoading(true);
      const { data } = await SendUserCredentialsApi(id);
      if (data?.success) {
        toast.success(data?.message);
        setIsOpenModal(false);
      }

      setIsReqLoading(false);
    } catch (error) {
      toast.error(error?.response?.data?.message);
      setIsReqLoading(false);
    }

  }
  return (
    <div>
      <ConfirmationModal
        isOpen={isOpenModal}
        setIsOpen={setIsOpenModal}
        type='success'
        message='Are you sure to send login Details ?'
        onConfirm={() => SendCredentials(true)}
        isLoading={isReqLoading}
        loadingLabel='Sending credentials...'
      />
    </div>
  )
}

export default SendCredentials
